import {
  AccessDecisions,
  useAccessDecisions,
} from '@domain/access-control/blocs/hooks/use-access-decisions';
import { EmployeeSubject } from '@domain/access-control/types/employee-subject';
import { useMemo } from 'react';
import { useSalesPortalEmployeeRole } from '@/experiences/sales-portal/blocs/hooks/use-sales-portal-employee-role';

/**
 * The policy decision point for the sales portal. It assembles the signed-in
 * user's EmployeeSubject for a supplier. It routes the subject through the
 * access-control domain's useAccessDecisions. The Apollo cache backs the
 * employee-role query, so all callers share one lookup.
 */
export const useSalesPortalAccess = (
  supplierUUID: string,
): AccessDecisions<EmployeeSubject> => {
  const { employeeRole, error, loading, refetch } =
    useSalesPortalEmployeeRole(supplierUUID);

  const subject = useMemo<EmployeeSubject>(
    () => ({ role: employeeRole }),
    [employeeRole],
  );

  return useAccessDecisions({
    error,
    loading,
    retry: () => refetch().catch(() => {}),
    subject,
  });
};
